import React, { useContext } from 'react';
import { withRouterHooks } from '../../../routes/router.hooks';
import './styles.css';
import { ContextMenuContext } from './context/ContextMenu.context';
import ContextItem from './components/ContextMenu.item';

const ContextWidget = () => {
  const { navData } = useContext(ContextMenuContext);

  return (
    <div className="flex flex-col w-full divide-y border rounded-md shadow-sm bg-white context-menu-container">
      {navData.widgetData.elements.map((element, index) => (
        <ContextItem
          key={`context-item-${index}`}
          context={element}
          currentDataID={navData.widgetData.dataID}
        />
      ))}
    </div>
  );
};

export default withRouterHooks(ContextWidget);
